<table class="table-condensed">
	@for (fpc of chosenFPCs; track fpc) {
		<tr class="table table-condensed">
			@if (fpc.familyDescription !== '') {
				<td>{{ fpc.familyDescription }}</td>
				<td>{{ fpc.variantDescription }}</td>
			}
		</tr>
	}
	<tr>
		<td>VIN number</td>
		<td>{{ VINNumber }}</td>
	</tr>
</table>
